import {BaseManager} from "../../../infrastructure/managers/base-manager";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../bootstrap/models/site-config";
import {DeviceViewModel} from "../../models/device.view-model";
import {singleton} from "../../../infrastructure/decorators/singleton";
import {BreadcrumbsItemModel} from "./breadcrumbs.item-model";
import {RouteModel} from "../../components/router/models/route-model";
import {ROUTE_NAMES, SITE_DOMAINS} from "../../consts";
import {NavigationManager} from "../navigation-manager";
import {RouterController} from "../../components/router/router-controller";
import {action, makeObservable, observable, computed} from "mobx";
import {BreadcrumbsListSchemaModel} from "../../models/schema/breadcrumbs-list-schema-model";
import {SchemaManager} from "../schema-manager";

@singleton
export class BreadcrumbsManager extends BaseManager {
  @observable list: Array<BreadcrumbsItemModel>;
  @observable _showBreadcrumbs: Array<BreadcrumbsItemModel>;
  navigationManager: NavigationManager;
  routeController: RouterController;
  schemaManager: SchemaManager;

  static injectables = [...BaseManager.injectables, NavigationManager, RouterController, SchemaManager];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    device: DeviceViewModel,
    navigationManager: NavigationManager,
    routerController: RouterController,
    schemaManager: SchemaManager
  ) {
    super(domUtils, logger, siteConfig, device);

    makeObservable(this);

    this.list = [];
    this.navigationManager = navigationManager;
    this.routerController = routerController;
    this.schemaManager = schemaManager;

    // routerController.registerToRouteChange(() => this.clean());
  }

  @computed get showBreadcrumbs() {
    const relevantRoutes = [
      ROUTE_NAMES.competitionScores,
      ROUTE_NAMES.competitorScores,
      ROUTE_NAMES.game,
      ROUTE_NAMES.athlete
    ];

    return !!relevantRoutes.includes(this.navigationManager.currentLinkModel?.name);
  }

  @computed get hasBreadcrumbs(): Boolean {
    return this.list?.length > 1;
  }

  get listPrefix(): String {
    return '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":\n['
  }

  get nextPosition(): String {
    return this.list?.length + 1
  }

  @action add(name, model, entityType, metaDataIncluded) {
    const url: String = this.getModelUrl(model)
    const position: String = this.nextPosition;
    const item = new BreadcrumbsItemModel(position, name, url, model, entityType, metaDataIncluded)


    this.list.push(item);

    return item
  }

  @action clean() {
    this.list = []
  }

  toString(): String {
    let schemaData: BreadcrumbsListSchemaModel = null;

    if (this.hasBreadcrumbs) {
      schemaData = this.schemaManager.createBreadcrumbs(this.list).toString();
    }

    return schemaData
  }

  getModelUrl(model): String {
    const routeModel: RouteModel = this.routerController.findRouteByName(model.name);
    const url: String = `${SITE_DOMAINS.full}${this.navigationManager.createUrl(routeModel.path, model, false)}`;  //TODO: hash: false

    return url;
  }
}
